import ErrorAlert from "../../ErrorAlert";
import { Loading } from "../../Loading";
import { useUnifiedAuth } from "../../unified-auth";
import {
  detectAuthenticationResults,
  parseAuthenticationResults,
  redirectToErrorPage,
} from "./utils";

/**
 * This callback page is just a basic landing page to end up on when a user is redirected from the IdP, if
 * you land here you will just either see an error page or a loading page.
 * @constructor
 */
export default function Callback() {
  const { isLoading, error } = useUnifiedAuth();

  const handleCallbackOnError = (): boolean => {
    const opts = parseAuthenticationResults();
    if (detectAuthenticationResults(opts)) {
      // If the error is handled, we redirect to the error page with an error message
      redirectToErrorPage(opts);
      return true;
    }
    return false;
  };

  if (handleCallbackOnError()) {
    return null; // If there's an error, the function will handle the redirect
  }

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    if (error instanceof Error) {
      const opts = { error: error.message };
      if (detectAuthenticationResults(opts)) {
        redirectToErrorPage(opts);
        return null; // Redirects to the error page instead of rendering
      }
    }
    return <ErrorAlert input={error} />;
  }

  return (
    <>
      <main className="login"></main>
    </>
  );
}
